import {
  ExperimentClient,
  GatesService,
  TreatmentService,
  Treatment,
  ExperimentType,
} from '@grammarly/experimentation-js-sdk'

import { ManakinExperiments, ExperimentNamesSet, StatsigExperiments } from './experiments'
import { Gates, GatesSet, StatsigGates } from './gates'
import { GR_ENV } from '../../../constants'
import { getApplicationRequestHeaders } from '../request'
import { FacadeService } from '../facade'
import { getExperimentOverrides } from './overrides'

const TIMEOUT = 10 * 1000

export const createExperimentClient = (
  fetchFn: typeof window.fetch,
  facadeService: FacadeService
): ExperimentClient => {
  // on client side, binding fetch to window is need to avoid error "illegal invocation"
  const treatmentService = new TreatmentService(
    IS_CLIENT_SIDE ? fetchFn.bind(window) : fetchFn,
    {
      getApplicationHeaders: getApplicationRequestHeaders,
      timeout: TIMEOUT,
    },
    GR_ENV
  )

  const gateService = new GatesService(
    IS_CLIENT_SIDE ? fetchFn.bind(window) : fetchFn,
    {
      getApplicationHeaders: getApplicationRequestHeaders,
      timeout: TIMEOUT,
    },
    GR_ENV
  )

  const experimentClient = new ExperimentClient(
    treatmentService,
    Object.values({ ...ManakinExperiments, ...StatsigExperiments }),
    gateService,
    Object.values({ ...Gates, ...StatsigGates }),
    {
      ssrDisableLogging: !IS_CLIENT_SIDE,
    }
  )

  // TODO: Consider splitting treatments from Facade.
  const treatments = facadeService.get().treatments || []
  const overrides: { [key: string]: string } = IS_CLIENT_SIDE ? getExperimentOverrides() : {}

  const treatmentsWithOverrides: Treatment[] = [
    ...Object.entries(overrides).map(([name, experienceName]) => {
      const experimentType = (GatesSet.has(name) ? 'gate' : 'experiment') as ExperimentType

      return {
        experimentName: name,
        groupName: `${experienceName}_1`,
        experimentId: 'dummy',
        type: experimentType,
      }
    }),
    ...treatments,
  ].filter((treatment) => GatesSet.has(treatment.experimentName) || ExperimentNamesSet.has(treatment.experimentName))

  experimentClient.setPrefetchedTreatments(treatmentsWithOverrides)

  return experimentClient
}
